import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import * as React from "react"
import * as ReactDOM from "react-dom"
import RecettesTable from "./recettes-table-generator"
import { ReportConfiguration } from "../../../configuration"
import { getHtmlToPowerPointBaseOptions } from "../../pptx-configuration/slides"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import * as CashFlowDomain from "../../../../../domain/sfp/cash-flow-domain"
import * as LoanDomain from "../../../../../domain/sfp/loan-domain"
import * as ResultDomain from "../../../../../domain/sfp/result-domain"
import * as Model from "../../../../../model"

export function checkRecettesReellesSection(
	configuration: ReportConfiguration
): boolean {
    const capaciteNette = configuration.budgetAnnexe.capaciteNette
	return capaciteNette
}

export function createRecettesReellesSection(
	pptx: PptxGenJS,
	configuration: ReportConfiguration,
	numbering: number[],
	localAuthority: Model.LocalAuthority,
	scenario: Model.Scenario,
	ppi: Model.Ppi,
	loanDecompositions: Model.LoanDecomposition[],
	years: number[],
	budgetData: any
): DocumentSection {
	const title = formatTitle("Recettes reelles de fonctionnement", numbering)
	const slides: Slide[] = []
	const budgetAnnexCapacitBrute = configuration.budgetAnnexe.budgetsAnnexes
	const reimbursedCapitals = []
	const remainingCapitals = []

	years.forEach(y => {
		reimbursedCapitals.push(
			LoanDomain.getTotalYearReimbursedCapital(loanDecompositions, y))

		remainingCapitals.push(
			LoanDomain.getTotalYearRemainingCapital(loanDecompositions, y))
	})

	const grossCashFlows = CashFlowDomain.calculateGrossCashFlow(
		localAuthority, scenario, ppi, loanDecompositions, years)
	const netCashFlows = CashFlowDomain.calculateNetCashFlow(
		grossCashFlows, reimbursedCapitals)
	const debtRefunds = CashFlowDomain.calculateDebtRefundPercentage(
		grossCashFlows, reimbursedCapitals)
	const operationExpenses = ResultDomain.calculateOperationExpenses(
		localAuthority, scenario, ppi, loanDecompositions, years)
	const operationReceipts = ResultDomain.calculateOperationReceipts(
		localAuthority, scenario, ppi, loanDecompositions, years)
	const operationResult = ResultDomain.calculateResults(
		operationReceipts, operationExpenses)
	const deleveragingYears = CashFlowDomain.calculateCashFlowDeleveragingYears(
		grossCashFlows, remainingCapitals)
	if (budgetAnnexCapacitBrute) {
		const tableId = "management-report-retrospective-cash-flow"
		const tempDiv = document.createElement("div")
		document.head.appendChild(tempDiv)

		const table = <RecettesTable
		currency={configuration.currency}
		debtRefunds={debtRefunds}
		deleveragingYears={deleveragingYears}
		grossCashFlows={grossCashFlows}
		id={tableId}
		locale={configuration.locale}
		netCashFlows={netCashFlows}
		operationExpenses={operationExpenses}
		operationReceipts={operationReceipts}
		operationResult={operationResult}
		reimbursedCapitals={reimbursedCapitals}
		remainingCapitals={remainingCapitals}
		roundness={configuration.generalities.roundness}
		tableConfiguration={configuration.table}
		years={years}
		budgetData={budgetData}/>

		ReactDOM.render(table, tempDiv, () => {
			const options = getHtmlToPowerPointBaseOptions(title)
			pptx.addSlidesForTable(tableId, options)
			document.head.removeChild(tempDiv)
		})
	}

	return { slides, title }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/budgetGenerator/recettes-generator/index.tsx